import clsx from 'clsx';
import Link from 'next/link';
import { Icon, SemanticICONS } from 'semantic-ui-react';
import type { HeaderBanner } from 'types/ui/HeaderBanner';
import styles from './Banner.module.css';

interface IBannerProps {
  bannerContent: HeaderBanner;
  leftAligned?: boolean;
}

const Banner = ({ bannerContent, leftAligned = false }: IBannerProps) => {
  if (bannerContent.customContent) {
    return bannerContent.customContent;
  }
  const renderBannerContent = () => (
    <div className={styles.bannerContainer}>
      <button
        type="button"
        className={clsx(
          styles.textContainer,
          leftAligned ? styles.leftAligned : '',
          !bannerContent?.tapHandler ? styles.removePointer : '',
        )}
        onClick={() => bannerContent?.tapHandler && bannerContent.tapHandler()}
      >
        {bannerContent.faIconName && (
          <Icon
            name={bannerContent.faIconName as SemanticICONS}
            className={styles.bannerIcon}
          />
        )}
        <div className={styles.bannerContent}>{bannerContent.content}</div>
      </button>
    </div>
  );

  return bannerContent.href ? (
    <Link href={bannerContent.href}>{renderBannerContent()}</Link>
  ) : (
    renderBannerContent()
  );
};

export default Banner;
